import './testimonialSection.scss';

import Quote from '../../images/quote.png';
import Testimonial1 from '../../images/testimonial-1.png';
import Testimonial2 from '../../images/testimonial-2.png';
import Testimonial3 from '../../images/testimonial-3.png';

export const TestimonialSection = () => {
  const testimonials: Array<{ name: string; position: string; image: any; description: string }> = [
    {
      name: 'Jane Smith',
      position: 'Homeowner',
      image: Testimonial1,
      description:
        'Repair Pros provided exceptional service. Their attention to detail and quality workmanship exceeded our expectations. Highly recommend!',
    },
    {
      name: 'Thomas Johnson',
      position: 'Property Manager',
      image: Testimonial2,
      description:
        'The team at Repair Pros was professional and efficient. They completed the job on time and delivered outstanding results. We couldn’t be happier with their service.',
    },
    {
      name: 'Monique Williams',
      position: 'Tenant',
      image: Testimonial3,
      description:
        'We were impressed by the quality and speed of Repair Pros. They handled everything with utmost professionalism and care. Truly a top-notch service!',
    },
  ];

  return (
    <div id={'testimonials'} className={'testimonials'}>
      <div className={'testimonials__heading'}>
        <span id={'section-heading'}>Testimonials</span>
      </div>

      <div className={'testimonials__top'}>
        <div className={'testimonials__top__left'}>
          <h1>Hear What Our Customers Have to Say</h1>
        </div>
        <div className={'testimonials__top__right'}>
          <p>
            Our customers’ satisfaction is our top priority. Read what they have to say about their
            experiences with Repair Pros.
          </p>
        </div>
      </div>
      <div className={'testimonials__bottom'}>
        {testimonials.map(({ image, description, name, position }, index) => (
          <div className={'testimonials__bottom__item'} key={name + index}>
            <div style={{ width: '100%', height: '100%', display: 'flex', justifyContent: 'space-between' }}>
              <img
                src={image}
                style={{ height: 40, width: 40 }}
                className="testimonials__bottom__item__image"
              />
              <img style={{ height: 40, width: 40 }} src={Quote} />
            </div>

            <h5 style={{ color: 'white' }}>{name}</h5>
            <span>{position}</span>
            <div className="testimonials__bottom__item_border">
              <p>{description}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
